<mat-toolbar color="primary" class="expanded-toolbar footer"> <span>
	<button mat-button routerLink="/"></button>
</span>
<div fxLayout="row" fxShow="false" fxShow.gt-sm>
	<button mat-button>&copy; 2024</button>
	<button mat-button routerLink="/about-us">About</button>
	<button mat-button routerLink="/term-of-usage">Terms of Use</button>
	<button mat-button routerLink="/privacy-policy">Privacy Policy</button>
	<button mat-button routerLink="/write-to-us">Write to Us</button>
</div>
<div fxLayout="row" fxShow="false" fxShow.gt-sm>
	<button mat-button routerLink="/game"></button>
</div>
</mat-toolbar>

